/* eslint-disable @next/next/no-img-element */
import React from 'react'
import styled from '@emotion/styled'
import Image from 'next/image'
import { formatAddress, mq, useBooleanState } from '../../../../helpers'
import ArrowUp from '../../../../../public/images/arrow-up-red.svg'
import ArrowDown from '../../../../../public/images/arrow-down-red.svg'
import { gsColors } from '../../../../styles/Variables'

export const ADDRESS_VIEW_MODE = {
  DISPLAY: 'DISPLAY',
  SELECT: 'SELECT'
}

const AddressSelect = styled.div`
  margin: ${props => (props.step === 1 ? '0 15px' : '0')};
  position: relative;

  button {
    &:disabled {
      cursor: not-allowed;
    }
  }

  ${mq('min', '768px')} {
    height: 54px;
    max-width: 624px;
    margin-left: auto;
    margin-right: auto;
  }

  > .address-summary {
    border: none;
    background-color: transparent;
    border-bottom: 1px solid ${gsColors.black};
    cursor: pointer;
    font-size: 14px;
    height: 54px;
    line-height: 54px;
    overflow: hidden;
    padding: 0;
    text-overflow: ellipsis;
    transition: all 250ms;
    white-space: nowrap;
    position: relative;
    width: 100%;

    display: flex;
    justify-content: space-between;
    align-items: center;

    div {
      display: flex;
      align-items: center;

      p {
        margin-left: 8px;
        color: #000;
        font-family: Euclid;
        font-size: 18px;
        font-weight: 400;
        line-height: 120%;
        letter-spacing: 0.36px;
      }
    }
  }

  .menu {
    background-color: ${gsColors.white};
    max-height: 0;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    top: 100%;
    left: 0;
    transition: all 400ms ease-out;
    width: 100%;
    z-index: 500;

    border-left: 1px solid ${gsColors.greyPoupon};
    border-right: 1px solid ${gsColors.greyPoupon};
    border-bottom: 1px solid ${gsColors.greyPoupon};
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.06), 0px 4px 6px 0px rgba(0, 0, 0, 0.10);

    .saved-addresses {
      max-height: 170px;
      overflow-y: auto;

      > li {
        width: 100%;
        display: flex;
        height: 48px;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;

        button {
          all: unset;
          height: 100%;
          width: 100%;
          margin: 0;
          padding: 0 0 0 50px;
          border-bottom: 1px solid ${gsColors.greyPoupon};
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }



        &.selected {
          background-color: ${gsColors.sunsetOrange};

          button {
            color: #FFF;
          }
        }

        &:hover {
          &:not(.selected) {
            button {
              color: ${gsColors.sunsetOrange};
            }
          }
        }
      }
    }

    .address-summary {
      font-size: 14px;
      line-height: 1.57;
    }

    .add-address {
      padding: 15px;

      button {
        background-color: ${gsColors.white};
        border: 1px solid ${gsColors.grape};
        color: ${gsColors.honeyFlower};
        font-size: 14px;
        letter-spacing: 1px;
        height: 48px;
        text-transform: uppercase;
      }
    }
  }

  ${props =>
    props.addressMenuVisibility &&
    `
      .menu {
        opacity: 1;
        max-height: 500px;
      }
    `}
`

const AddressView = ({
  address,
  addresses,
  dispatch,
  markets,
  mode,
  selectedAppointment = false,
  step
}) => {
  const [addressMenuVisibility, setAddressMenuVisibility] = useBooleanState()
  const hasSavedAddresses = addresses?.length >= 1

  const selectAddress = i => () => {
    const address = addresses[i]

    setAddressMenuVisibility()

    switch (step) {
      case 1:
        return dispatch({
          address,
          market: markets.find(m => m.id === address.marketId)
        })
      case 3:
        return dispatch({
          address
        })
      default:
        break
    }
  }

  const addAddress = () => {
    if (step === 1) {
      setAddressMenuVisibility()

      return dispatch({
        address: {
          id: '',
          street: '',
          city: '',
          state: '',
          zip: '',
          apartment: '',
          notes: '',
          type: '',
          pets: '',
          latitude: 0,
          longitude: 0
        },
        allowAddressSelect: false,
        market: null
      })
    }
  }

  if (mode === ADDRESS_VIEW_MODE.SELECT && (!address || !addresses)) {
    return null
  }

  return (
    <AddressSelect {...{ addressMenuVisibility, step }}>
      <button
        disabled={mode === ADDRESS_VIEW_MODE.DISPLAY}
        tabIndex={0}
        className={`address-summary ${hasSavedAddresses ? 'many' : ''}`}
        onClick={() =>
          hasSavedAddresses &&
        (!!selectedAppointment || step === 1) &&
        setAddressMenuVisibility()
        }
        onKeyPress={e => {
          if (e.key === 'Enter') {
            if (
              hasSavedAddresses &&
            (!!selectedAppointment || step === 1)
            ) {
              setAddressMenuVisibility()
              return
            }
          }

          return false
        }}
      >
        <div>
          <img src='/images/new-location-icon.svg' alt='' aria-hidden='true' className='location-icon' />
          <p>{formatAddress(address)}</p>
        </div>
        {
          (hasSavedAddresses && mode !== ADDRESS_VIEW_MODE.DISPLAY) ? (
            addressMenuVisibility ? (
              <Image src={ArrowUp} alt="" aria-hidden="true" />
            ) : (
              <Image src={ArrowDown} alt="" aria-hidden="true" />
            )
          ) : null
        }
      </button>
      <div className="menu">
        <ul className="saved-addresses">
          {addresses.map((a, i) => {
            return (
              <li
                className={a.id === address.id ? 'selected' : null}
                key={i}
              >
                <button className='address-list-summary' onClick={selectAddress(i)}>
                  {formatAddress(a)}
                </button>
              </li>
            )
          })}
          {step === 1 && (
            <li>
              <button className='address-list-summary' onClick={addAddress}>
              + Add New Address
              </button>
            </li>
          )}
        </ul>
      </div>
    </AddressSelect>
  )
}
export default AddressView
